import { combineReducers } from "redux";
import { paymentReducer, cBankListReducer } from "../../views/bank/reducer";

export default combineReducers({ 
  paymentList: paymentReducer , cBankList: cBankListReducer
});
